import moment from 'moment'
import React, { useEffect } from 'react'
import { Button, Icon, Image, List, Popup, Table } from 'semantic-ui-react'
import CircularLabel from '../../../../components/Labels/CircularLabel'
import { _MIXEDCOLORS } from '../../../../constants/colors'
import { IUserDetail } from '../../../../types/user'
import { checkRole } from '../../../../utils/checkRole'
import { createInitials } from '../../../../utils/createInitials'
import { IEmployee } from '../../../settings/types/employee'
import { ITimeTracking } from '../../../time-tracking/types/timeTracking'
import { IDirectCost } from '../../types/directAndPassTroughCosts'
import { IProjectActivity } from '../../types/projectActivity'


interface Props {
  selectedActivity: IProjectActivity | IDirectCost
  timeTrackingEntries: ITimeTracking[]
  query?: string
  archived: boolean
  user: IUserDetail | null
  getTimeTracking: (queryParams: Record<string, string>) => void
  selectEntry: (entry: ITimeTracking) => void
  openModal: (open: boolean) => void
  openConfirmModal: (open: boolean) => void
}

const ActivityDetailsTimesheetComponent = (props: Props): JSX.Element => {

  const { selectedActivity, timeTrackingEntries, query, getTimeTracking, selectEntry, openModal, openConfirmModal, archived, user } = props

  const _header = [
    { text: 'Member', padding: '6px 0 6px 12px', width: '305px' },
    { text: 'Duration', padding: '6px 0 6px 0', width: '65px' },
    { text: 'Date', padding: '6px 0 6px 0', width: '65px' },
    { text: '', padding: '6px 0 6px 0', width: '100%' }
  ]

  useEffect(() => {
    if (selectedActivity.id !== '') {
      const _query = query ? query : 'activity'
      getTimeTracking({ [_query]: selectedActivity.id.toString(), module: 'task_sidebar' })
    }
  }, [getTimeTracking, selectedActivity, query])

  const renderTableHeader = () => {
    return _header.map((h, idx) => {
      return (
        <Table.HeaderCell key={idx} style={{ color: '#747678', padding: h.padding, border: 'none', minWidth: h.width, maxWidth: h.width, width: h.width }}>{h.text}</Table.HeaderCell>
      )
    })
  }

  const handleOptionSelect = (entry: ITimeTracking, option: string) => {
    selectEntry(entry)
    if (option === 'edit') {
      openModal(true)
    } else {
      openConfirmModal(true)
    }
  }

  const renderAvatar = (emp: IEmployee) => {
    const randColor = Math.floor((Math.random() * (_MIXEDCOLORS.length - 1) + 1))
    return emp.photo ?
      <Image
        circular={true}
        src={emp.photo}
        style={{ minWidth: '25px', minHeight: '25px', maxWidth: '25px', maxHeight: '25px', objectFit: 'cover' }}
      /> : <CircularLabel
        width='25px'
        height='25px'
        style={{ fontSize: '12px' }}
        content={createInitials(emp)}
        color={emp.color ? emp.color : _MIXEDCOLORS[randColor]}
      />
  }

  const renderAdditionalDropdown = (entry: ITimeTracking) => {
    return (
      <List style={{ width: '7rem' }}>
        <List.Item content={'Edit'} onClick={() => handleOptionSelect(entry, 'edit')} style={{ cursor: 'pointer' }} />
        <List.Item content={'Delete'} onClick={() => handleOptionSelect(entry, 'delete')} style={{ cursor: 'pointer' }} />
      </List>
    )
  }

  const renderTableBody = () => {
    return timeTrackingEntries.map((e, idx) => {
      const splitDuration = e.duration.toString().split(':')
      let duration = ''
      if (splitDuration[0] === '1 00' && splitDuration[1] === '00' && splitDuration[2] === '00') {
        duration = '24:00 hrs'
      } else {
        duration = `${splitDuration[0]}:${splitDuration[1]} hrs`
      }
      return (
        <Table.Row key={idx} style={{ borderTop: idx === 0 ? 'none' : '', display: 'table', tableLayout: 'inherit' }}>
          <Table.Cell style={{ display: 'flex', alignItems: 'center', padding: '18px 0', width: '305px', minWidth: '305px', maxWidth: '305px' }}>
            {renderAvatar(e.employee)}
            <div style={{ marginLeft: '4px' }}>
              <p style={{ margin: '0 0 0 4px', fontSize: '12px', color: '#172533', letterSpacing: '.25px', whiteSpace: 'nowrap' }}>{e.employee.full_name}</p>
              <div style={{ display: 'flex', marginLeft: '4px', fontSize: '12px', color: '#172533', letterSpacing: '.25px', whiteSpace: 'nowrap' }}>
                <p style={{ whiteSpace: 'nowrap', display: 'flex', gap: '2px', color: '#848484', marginRight: '4px' }}>DEPARTMENT:</p>{e.employee.department_name}</div>
            </div>
          </Table.Cell>
          <Table.Cell style={{ fontSize: '12px', color: '#172533', letterSpacing: '.25px', padding: '18px 0', width: '65px', minWidth: '65px', maxWidth: '65px' }}>{duration}</Table.Cell>
          <Table.Cell style={{ fontSize: '12px', color: '#172533', letterSpacing: '.25px', padding: '18px 0', width: '65px', minWidth: '65px', maxWidth: '65px' }}>{moment(e.date).format('DD/MM/YY')}</Table.Cell>
          <Table.Cell style={{ fontSize: '12px', color: '#172533', letterSpacing: '.25px', padding: '18px 0', width: 'auto' }}>
            <Popup
              trigger={
                <Button
                  size='small'
                  disabled={!archived || !(user && (checkRole(user, [23]) || (user.id === e.employee.user && checkRole(user, [22]))))}
                  secondary={true}
                  icon={<Icon name='ellipsis horizontal' style={{ fontSize: '0.7rem' }} />}
                  style={{ padding: '0', borderRadius: '.4rem', width: '1.5rem', height: '1.5rem', marginTop: '1%' }}
                />
              }
              style={{ marginLeft: '0.5rem' }}
              content={renderAdditionalDropdown(e)}
              on='click'
              position='bottom left'
            />
          </Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <Table unstackable basic='very' style={{ padding: '0 32px', margin: 0 }}>
      <Table.Header style={{ height: '40px', backgroundColor: '#F4F7F9', display: 'table', tableLayout: 'inherit' }}><Table.Row>{renderTableHeader()}</Table.Row></Table.Header>
      <Table.Body style={{ display: 'block', height: 'calc(100vh - 288px)', overflow: 'hidden auto' }}>{renderTableBody()}</Table.Body>
    </Table>
  )
}

export default ActivityDetailsTimesheetComponent
